/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { Form as FormUi, Container, TextArea, Button, Input, Segment, Dropdown, Icon, Search, } from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { min, isEmpty } from "lodash";
import {
    successAlertDispatcher,
    errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
    createShipmentDispatcher,
    deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";
import ShipmentDetails from './shipmentDetails';
import OrderDeatils from './orderDetails';
import DeliveryDetails from './deliveryDetails';


const EditNewOrder = ({
    values,
    vehicleTypeMaster,
    setFieldValue,
    touched,
    errors,
    handleSubmit,
    shipment,
    shipmentEdit,
    routeCodes,
    routeNames,
    mode,
    isSubmitting,
    deleteAllOrderDispatcher,
    t,
    props
}) => {

    useEffect(() => {
    }, [])


    return (
        <React.Fragment>
            <ShipmentDetails />
            <OrderDeatils />
            <DeliveryDetails />
        </React.Fragment>
    );
};

const FormikShipment = withFormik({
    enableReinitialize: true,
    validationSchema: yup.object({
    }),
    // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
    mapPropsToValues: (props) => (
        {
            //movement_type: (props.shipmentEdit ? props.shipmentEdit.movement_type : localStorage.getItem("customerNumber") != 1122 ? "primary" : "import"),
        }),
    handleSubmit(values, { setFieldValue, setSubmitting, props }) {

    },
})(EditNewOrder);

const mapStateToProps = ({ shipment }) => {
    return {
        shipment,
    };
};

export default connect(mapStateToProps, {
    createShipmentDispatcher,
    successAlertDispatcher,
    errorAlertDispatcher,
    deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikShipment));
